import { render, staticRenderFns } from "./zbIndex.vue?vue&type=template&id=6bcb3790&"
import script from "./zbIndex.vue?vue&type=script&lang=js&"
export * from "./zbIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "zbIndex.vue"
export default component.exports